const { default: objectUtils } = require('../_helpers/objectUtils')
const regexConstant = require('./regexes.constant')

const regexNameConstant = objectUtils.invertObject(regexConstant)

module.exports = regexNameConstant
